import * as React from "react";
import Skeleton from "react-loading-skeleton";

export interface ICommonShimmer {
  className?: string;
  number?: number;
}
const Common_Shimmer: React.FC<ICommonShimmer> = (props: ICommonShimmer) => {
  return (
    <>
      <div
        className={`common-shimmer ${props.className ? props.className : ""}`}
      >
        <Skeleton
          className="SkeletonTile h-40"
          count={props.number ? props.number : 4}
        />
      </div>
    </>
  );
};

export default Common_Shimmer;
